const csvTemplate = `sales_team_id,email,month,year,value,value_type
61dc127788daed0d7aae40db,johndoe23@gmail.com,1,2025,97601376,amount
61dc127788daed0d7aae40db,johndoe23@gmail.com,1,2025,97601376,amount
61dc127788daed0d7aae40db,johndoe23@gmail.com,1,2025,292336976,amount
61dc127788daed0d7aae40db,johndoe23@gmail.com,1,2025,595978302,amount
61dc127788daed0d7aae40db,johndoe23@gmail.com,2,2025,129689899,amount
61dc127788daed0d7aae40db,johndoe23@gmail.com,2,2025,334141165,amount`;

export default csvTemplate;
